import {
  MaterialReactTable,
  useMaterialReactTable,
} from "material-react-table";
import React, { useEffect, useMemo, useState } from "react";
import api from "../Axios/api";
import moment from "moment";
import Swal from "sweetalert2";
import { Trash2 } from "lucide-react";
import Loader from "../../components/common/Loader";
function PurchaseEntry() {
  const [purchasePaymentList, setPurchasePaymentList] = useState([]);
  const [isloading, setIsLoading] = useState(false);
  const [selectedRowIds, setSelectedRowIds] = useState({});
  const [multiselect, setMultiselect] = useState(false);
  const [multiselectModal, setMultiselectModal] = useState(false);
  const [month, setMonth] = useState("");
  const [multiformState, setMultiformState] = useState({
    id: [],
    amount: [],
    receiptNo: [],

    date: "",
    totalAmount: "",
    partyName: "",
  });
  const getPurchasePaymentList = async () => {
    try {
      setIsLoading(true);
      const response = await api.get(`/purchase-payment/get?month=${month}`);
      setPurchasePaymentList(response.data);
      setIsLoading(false);
    } catch (error) {
      console.error(error);
    }
  };

  const columns = useMemo(
    () => [
      {
        accessorKey: "receipt_no",
        header: "Receipt No.",
        enableColumnFilter: true,
        size: 150,
        Cell: ({ cell, row }) => (
          <div className="max-h-12 overflow-y-auto">
            <div className="font-bold">{cell.getValue()}</div>
            <code>
              {moment(row.original.entry_date[0]).format("DD/MM/YYYY")}
            </code>
          </div>
        ),
      },
      {
        accessorKey: "invoice_number",
        header: "Invoice No.",
        enableColumnFilter: true,
        size: 150,
        Cell: ({ cell, row }) => (
          <div className="max-h-12 overflow-y-auto">
            <div className="font-bold">{cell.getValue()}</div>
            <code>
              {moment(row.original.invoice_date).format("DD/MM/YYYY")}
            </code>
          </div>
        ),
      },
      {
        accessorKey: "vendor_name",
        header: "Party Name",
        size: 200,
        enableColumnFilter: true,
      },
      {
        accessorKey: "grn_value",
        header: "GRN Value",
        size: 120,
        enableColumnFilter: true,
        Cell: ({ cell, row }) => (
          <div className="max-h-12 overflow-y-auto">
            <div className="font-bold">₹{cell.getValue()}</div>
            <div
              className={`${
                row.original.dcr_type === "credit"
                  ? "text-red-600"
                  : row.original.dcr_type === "debit"
                  ? "text-green-600"
                  : "text-gray-600"
              } font-bold`}
            >
              ₹{row.original.dcr_amount}
            </div>
          </div>
        ),
      },
      {
        accessorKey: "total_amount",
        header: "Total Amount",
        size: 180,
        enableColumnFilter: true,
        Cell: ({ cell }) => <div>{cell.getValue()}</div>,
      },
      {
        accessorKey: "po_number",
        header: "PO No.",
        size: 150,
        enableColumnFilter: true,
        Cell: ({ cell }) => (
          <div className="max-h-10 overflow-y-auto">
            {cell.getValue().map((poNo) => (
              <div key={poNo}>{poNo}</div>
            ))}
          </div>
        ),
      },
      {
        accessorKey: "remark",
        header: "Remark",
        size: 200,
        enableColumnFilter: true,
      },
      {
        accessorKey: "_id",
        header: "Action",
        size: 100,
        enableColumnFilter: true,
        Cell: ({ row }) => (
          <div className="flex items-center">
            {row.original.status === "pending" ? (
              <button
                type="button"
                className="text-white bg-gradient-to-r from-violet-500 via-violet-600 to-violet-700 hover:bg-gradient-to-br focus:outline-none font-medium rounded-lg text-sm px-3 py-1.5 text-center me-2 mb-2"
                onClick={() => {
                  handleModalOpen(row);
                }}
              >
                Payment
              </button>
            ) : (
              <button
                type="button"
                className="text-white bg-gradient-to-r from-green-500 via-green-600 to-green-700 hover:bg-gradient-to-br focus:outline-none font-medium rounded-lg text-sm px-3 py-1.5 text-center me-2 mb-2"
                onClick={() => {
                  handleModalOpen(row);
                }}
              >
                Paid
              </button>
            )}
            <button
              type="button"
              className="text-white bg-gradient-to-r from-red-500 via-red-600 to-red-700 hover:bg-gradient-to-br focus:outline-none font-medium rounded-lg text-sm px-3 py-1.5 text-center me-2 mb-2"
              onClick={() => {
                handleDelete(row.original._id);
              }}
            >
              <Trash2 size={20} />
            </button>
          </div>
        ),
      },
    ],
    []
  );

  const table = useMaterialReactTable({
    columns,
    enableRowSelection: true,
    data: purchasePaymentList,
    onRowSelectionChange: setSelectedRowIds,
    state: { rowSelection: selectedRowIds },
    renderToolbarAlertBannerContent: ({ table }) => {
      //make according to condition selected true false
      setMultiselect(Object.keys(selectedRowIds).length > 0);
      return (
        <div className="flex gap-4 px-1 mt-2">
          <button
            className="p-1 bg-[#EEEDEB] rounded-t-lg shadow-sm"
            onClick={multiProceed}
          >
            <span className="text-sm">Multiple Proceed</span>
          </button>
        </div>
      );
    },
  });

  const multiProceed = () => {
    const selected = table
      .getSelectedRowModel()
      .flatRows.map((row) => row.original);
    // console.log("bey",selected);return;
    const Ids = selected.map((item) => item._id);
    const partyName = selected.map((item) => item.vendor_name);
    const receiptNo = selected.map((item) => item.receipt_no);
    const amount = selected.map((item) => item.total_amount);
    const totalAmount = selected.reduce(
      (sum, item) => sum + (item.total_amount || 0),
      0
    );
    // console.log(receiptNo)
    setMultiformState({
      id: Ids, //Pass in Api
      amount: amount, //Pass in Api

      totalAmount: totalAmount, //show in modal
      receiptNo: receiptNo,
      partyName: partyName,  
    });
    setMultiselectModal(true);
  };
  const handleDelete = (id) => {
    try {
      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      }).then(async (result) => {
        if (result.isConfirmed) {
          await api.delete(`/purchase-payment/delete/${id}`);
          Swal.fire({
            title: "Deleted!",
            text: "Your data has been deleted.",
            icon: "success",
          });
          getPurchasePaymentList();
        }
      });
    } catch (error) {
      console.error(error);
      Swal.fire({
        title: "Payment Failed!",
        text: "Failed to submit payment. Please try again later.",
        icon: "error",
      });
    }
  };

  const formatAmount = (amount) => {
    return new Intl.NumberFormat("en-IN", {
      style: "currency",
      currency: "INR",
    }).format(amount);
  };

  const handleModalOpen = (rowData) => {
    // console.log("hi modal",rowData.original);return
    const prevAmount = rowData.original.payment_details.reduce(
      (acc, item) => acc + Number(item.paid_amount),
      0
    );
    Swal.fire({
      icon: "warning",
      title:
        rowData.original.status === "pending"
          ? "Are you sure?"
          : "Payment Details",
      html: `
        <div style="font-size: 20px; font-weight: bold;">
          Party: <span class="text-violet-600">${
            rowData.original.vendor_name
          }</span>
        </div>
        <div style="font-size: 20px; font-weight: bold;">
          <div>Payment: <span style="color:#296106">${formatAmount(
            rowData.original.total_amount
          )}</span></div>
          <div>Balance: <span style="color:red">${formatAmount(
            rowData.original.total_amount - prevAmount
          )}</span></div>
        </div>
        <table class="w-full mb-4 text-center border-collapse leading-8 text-sm">
          <thead>
            <tr style="border-bottom: 0.5px solid #ddd; color:#B5B7C0;">
              <th>SN</th>
              <th>Amount</th>
              <th>Date</th>
            </tr>
          </thead>
          <tbody>
          ${
            rowData.original.payment_details.length === 0
              ? '<tr class="border"><td colspan="4">Data Not Found!</td></tr>'
              : rowData.original.payment_details.map((item, index) => {
                  return `<tr class="border-b">
                  <td>${index + 1}</td>
                  <td>${formatAmount(item.paid_amount)}</td>
                  <td>${moment(item.payment_date).format("DD/MM/YYYY")}</td>
                </tr>`;
                })
          }
          <tr>
            <td colspan="2" class="font-bold">Total Paid:</td>
            <td class="font-bold text-[#296106]">${formatAmount(
              prevAmount
            )}</td>
            <td></td>
          </tr>
          </tbody>
        </table>
        ${
          rowData.original.status === "pending"
            ? `<div class="flex justify-between">
          <input type="number" id="amount" class="w-[30%] rounded border border-[#D5D7DA] py-1.5 px-3 ring-inset placeholder:text-gray-400 focus:ring-2 focus:ring-inset sm:text-sm sm:leading-6" placeholder="Enter Amount">
          <input type="date" id="transactionDate" class="w-[30%] rounded border border-[#D5D7DA] py-1.5 px-3 ring-inset placeholder:text-gray-400 focus:ring-2 focus:ring-inset sm:text-sm sm:leading-6">
        </div>`
            : ""
        }
      `,
      inputAttributes: {
        autocapitalize: "off",
      },
      showCancelButton: rowData.original.status === "pending",
      confirmButtonText:
        rowData.original.status === "pending" ? "Submit" : "OK",
      preConfirm: () => {
        if (rowData.original.status === "pending") {
          const totalAmount = rowData.original.total_amount;
          const amount = document.getElementById("amount").value;
          const transactionDate =
            document.getElementById("transactionDate").value;
          const status =
            totalAmount === Number(amount) + prevAmount ? "paid" : "pending";

          if (!amount || !transactionDate) {
            Swal.showValidationMessage("Please fill all fields.");
            return false;
          } else if (totalAmount < Number(amount) + prevAmount) {
            Swal.showValidationMessage(
              "Payment amount should not exceed total amount."
            );
            return false;
          }

          // submit details to api using axios patch request
          api
            .patch(`/purchase-payment/update/${rowData.original._id}`, {
              paid_amount: Number(amount),
              payment_date: moment(transactionDate).format("YYYY-MM-DD"),
              status,
            })
            .then((response) => {
              Swal.fire({
                title: "Payment Submitted!",
                text: `Paid Amount: ₹${formatAmount(
                  amount
                )}, Date: ${moment(transactionDate).format("DD/MM/YYYY")}`,
                icon: "success",
                timer: 5000,
              });
              getPurchasePaymentList();
            })
            .catch((error) => {
              console.error(error);
              Swal.fire({
                title: "Payment Failed!",
                text: "Failed to submit payment. Please try again later.",
                icon: "error",
              });
            });
        }
      },
      allowOutsideClick: () => !Swal.isLoading(),
    });
  };

const handleSubmit = async () => {
  try {
    await api.patch(`/purchase-payment/multi-payment`, {
      id: multiformState.id,
      amount: multiformState.amount,
      date: moment(multiformState.date).format("YYYY-MM-DD"),
    });

    Swal.fire({
      title: "Payment Submitted!",
      text: `Paid Amount: ₹${Number(multiformState.totalAmount).toFixed(2)}, Date: ${moment(multiformState.date).format("DD-MM-YYYY")}`,
      icon: "success",
      timer: 5000,
    });
    setMultiselectModal(false);
    getPurchasePaymentList();
  } catch (error) {
    console.error(error);
    Swal.fire({
      title: "Error!",
      text: "Failed to submit payment.",
      icon: "error",
    });
  }
};

  useEffect(() => {
    getPurchasePaymentList();
  }, [month]);
    useEffect(() => {
      const now = new Date();
      const year = now.getFullYear();
      const monthNum = String(now.getMonth() + 1).padStart(2, "0");
      const currentMonth = `${year}-${monthNum}`;
      setMonth(currentMonth);
  
    }, []);

  return (
    <div className="flex-1 px-5 w-full justify-center items-center">
      <div>
        <div className="bg-[#fdfdfd] border mt-4 p-2 flex w-full justify-between items-center rounded-md shadow">
          <div className="flex rounded-md items-center w-1/2">
            <h2 className="font-bold text-[#7286D3]">Purchase Payment</h2>
          </div>
              <div className="mb-4 space-x-2">
              <input
                type="month"
                value={month}
                onChange={(e) => {
                  setMonth(e.target.value);
                }}
                className="border rounded px-2 py-1 mt-4"
              />
            </div>
        </div>
      </div>
      <div className="w-full min-h-[500px] my-2 rounded-md shadow bg-[#fdfdfd]">
        {isloading ? <Loader /> : <MaterialReactTable table={table} />}
      </div>

      {multiselectModal && (
        <div
          className="fixed inset-0 bg-black/60 flex items-center justify-center z-50"
          onClick={() => setMultiselectModal(false)}
        >
          <div
            className="bg-white w-[30vw] md:w-[30vw] h-[40vh] rounded-2xl shadow-2xl p-6 flex flex-col animate-scale-in"
            onClick={(e) => e.stopPropagation()}
          >
            <h3 className="text-xl font-semibold mb-3 border-b pb-2 text-gray-700">
              Purchase Payment
            </h3>

            <div className="overflow-y-auto pr-2 space-y-3 flex-1">
              <div className="flex items-center justify-between gap-6">
                <div className="text-gray-700 text-md font-bold">
                  Party :
                  <span className="ml-2 text-xl font-bold text-blue-600">
                    {multiformState.partyName[0]}
                  </span>
                </div>
                <div className="text-gray-700 text-md font-bold">
                  Total :
                  <span className="ml-2 text-xl font-bold text-blue-600">
                    {Number(multiformState.totalAmount).toFixed(2)}
                  </span>
                </div>
              </div>

              <div>
                <label className="text-sm font-medium text-gray-600">
                  Receipt No
                </label>
                <input
                  type="text"
                  name="receiptNo"
                  disabled
                  value={multiformState.receiptNo}
                  className="w-full mt-1 border rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-400"
                />
              </div>

              <div>
                <label className="text-sm font-medium text-gray-600">
                  Date
                </label>
                <input
                  type="date"
                  value={multiformState.date}
                  onChange={(e) =>
                    setMultiformState((prev) => ({
                      ...prev,
                      date: e.target.value,
                    }))
                  }
                  className="w-full mt-1 border rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-400"
                />
              </div>

            </div>

            <div className="flex justify-end gap-3 pt-4">
              <button
                onClick={handleSubmit}
                className="bg-blue-600 text-white px-5 py-2 rounded-lg hover:bg-blue-700 transition"
              >
                Submit
              </button>

              <button
                onClick={() => setMultiselectModal(false)}
                className="bg-gray-300 px-5 py-2 rounded-lg hover:bg-gray-400 transition"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default PurchaseEntry;
